export interface GeneralSeoSettingsTranslationInput {
    language: string;
    seo_title: string;
    seo_keywords: string;
    meta_description: string;
    in_page_content: string;
}

export interface GeneralSeoSettingsPayload {
    page_key: string;
    open_graph_image_url: string | null;
    is_active: boolean;
    general_seo_setting_translations: GeneralSeoSettingsTranslationInput[];
}

export interface GeneralSeoSettings {
    pagination: {
        total_records: number;
        total_pages: number;
        limit: number;
        page: number;
    };
    records: GeneralSeoSettingsRecord[];
}
export interface GeneralSeoSettingsRecord {
    id: string;
    page_key: string;
    open_graph_image_url: string;
    is_active: boolean;
    createdAt: string;
    updatedAt: string;
    general_seo_setting_translations:
      | GeneralSeoSettingsTranslation
      | GeneralSeoSettingsTranslation[];
}
export interface GeneralSeoSettingsTranslation {
    __key?: string;
    general_seo_setting_id: string;
    language: string;
    seo_title: string;
    seo_keywords: string;
    meta_description: string;
    in_page_content: string;
    createdAt: string;
    updatedAt: string;
}